import { START_GET_FAMILIES } from '../types';
    
export const getFamilies = () => ({
    type: START_GET_FAMILIES
})